export default "__VITE_ASSET__BsYu7WPZ__"